// ── useAssistantMemory — memoria entre sesiones de Evo Brain ────────────────
// Ver qué aprendió (preferencias/decisiones/formatos) y borrar lo que no
// aplica (Roadmap Evo Brain, capacidad 1, 2026-08-06). Mismo shape simple
// que useAssistantHistory — volumen chico, sin paginación.

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../lib/api.js';

export type MemoryCategory = 'preference' | 'decision' | 'format' | 'other';

export interface MemoryEntry {
  id: number;
  content: string;
  category: MemoryCategory;
  sourceConversationId: number | null;
  entityType: string | null;
  createdAt: string;
  updatedAt: string;
}

const QUERY_KEY = ['assistant-memory'];

export function useAssistantMemory() {
  return useQuery<{ entries: MemoryEntry[] }>({
    queryKey: QUERY_KEY,
    queryFn: () => api.get<{ entries: MemoryEntry[] }>('/api/assistant/memory'),
  });
}

export function useForgetMemory() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => api.delete<{ ok: boolean }>(`/api/assistant/memory/${id}`),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: QUERY_KEY });
    },
  });
}
